import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

/**
 * Sales Counterpart = Clients
 * Market Counterpart = Custodians
 */

export interface ISalesCounterpartFetchApi {
  fetchSalesCounterparts(criteria: string, isActiveOnly?: boolean): Observable<ISalesCounterpart[]>;
  fetchSalesCounterpartsFromEliotCodes(eliotCodes: string[]): Observable<ISalesCounterpart[]>;
}

export type ICounterpartApi = ISalesCounterpartFetchApi;

export function counterpartApiConnector(http$: IHttpClient): ICounterpartApi {
  return {
    fetchSalesCounterparts(criteria: string, isActiveOnly?: boolean): Observable<ISalesCounterpart[]> {
      return http$
        .getJSON<ISalesCounterpart[]>({
          url: 'api/v1/clients/filter',
          params: {
            criteria,
            isActiveOnly,
          },
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchSalesCounterpartsFromEliotCodes(eliotCodes: string[]): Observable<ISalesCounterpart[]> {
      return http$
        .getJSON<ISalesCounterpart[]>({
          url: 'api/v1/clients',
          params: {
            eliot: eliotCodes,
          },
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
